var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-content"},[_c('div',{staticClass:"card"},[_c('h3',[_vm._v("There was an error with your payment")]),_c('SnackbarPrompt',{attrs:{"icon":"warning","variation":"warning"}},[_vm._v(_vm._s(_vm.errorMessage))]),_c('CustomButton',{attrs:{"variation":"primary","onClick":_vm.goBack}},[_vm._v("Back")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }